/**
 * Sidebar Controller
 *
 * Handles mobile sidebar toggle (open/close).
 */

import { Controller } from "/js/vendor/stimulus.js";

export default class SidebarController extends Controller {
  static targets = ["menu", "overlay"];

  toggle() {
    this.menuTarget.classList.toggle("open");
    this.overlayTarget.classList.toggle("open");
  }
}
